"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebounceValue = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useDebounceValue = function useDebounceValue(value) {
  var delayMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  (0, _react.useEffect)(function () {
    var handler = setTimeout(function () {
      return setDebouncedValue(value);
    }, delayMs);
    return function () {
      return clearTimeout(handler);
    };
  }, [delayMs, value]);
  return debouncedValue;
};

exports.useDebounceValue = useDebounceValue;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/hooks/useDebounceValue.js
// module id = 756
// module chunks = 209 210 211 212